import promise from 'es6-promise';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
promise.polyfill();
import Vue from 'vue';
import App from './App.vue';
import router from './router'; //路由
import ElementUI from 'element-ui'; //el
import 'element-ui/lib/theme-chalk/index.css'; //el样式表
import store from '@/store'; //vuex
// import '@/assets/css/eduBase.css'; //基础样式表
import eventBus from '@/utils/eventBus'; //消息组件
Vue.prototype.$eventBus = eventBus;
import windowSizeMixin from '@/mixins/windowSizeMixin'; //混入-浏览器窗口监听
import * as echarts from 'echarts'; // 在import的后面，echarts的前面加一个 * as
import './public/echarts-wordcloud.js';
Vue.prototype.$echarts = echarts;
Vue.mixin(windowSizeMixin);
Vue.use(ElementUI);

if (process.env.NODE_ENV === 'production') {
	if (window) {
		window.console.log = function () {};
	}
}

new Vue({
		render: (h) => h(App),
		router,
		store,
	}).$mount('#app');
